export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Hero */}
      <div className="text-center mb-16">
        <h1 className="text-6xl md:text-8xl font-steam mb-6 neon-text">
          ABOUT TEDDY-KGB
        </h1>
        <div className="h-[2px] bg-gradient-to-r from-transparent via-cyber-blue to-transparent mb-8" />
        <p className="text-xl text-gray-iron font-cyber leading-relaxed max-w-2xl mx-auto">
          A digital nomad navigating the shadows of cyberspace, documenting the journey
          through IT security's darkest corners.
        </p>
      </div>

      {/* Story */}
      <div className="card-neon mb-12 p-8">
        <h2 className="text-4xl font-steam text-steam-copper mb-6">The Origin Story</h2>
        <div className="space-y-4 text-gray-iron leading-relaxed">
          <p>
            In the depths of the digital underground, where neon lights flicker against
            brass gears and encrypted packets flow like steam through pipes, Teddy-KGB
            was born.
          </p>
          <p>
            This blog is a chronicle of one security researcher's journey through the
            ever-evolving landscape of IT security. From SQL injections to zero-day
            exploits, from privacy tools to secure coding practices, we explore it all.
          </p>
          <p>
            The name pays homage to the classic film "Rounders" while embracing a
            cyberpunk aesthetic that mirrors the chaotic beauty of modern cybersecurity.
          </p>
        </div>
      </div>

      {/* What We Cover */}
      <div className="mb-12">
        <h2 className="text-4xl font-steam text-cyber-blue mb-8 text-center">
          What We Cover
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="blog-card p-6">
            <h3 className="text-2xl font-steam text-danger-red mb-3">Security</h3>
            <p className="text-gray-iron text-sm">
              Deep dives into vulnerabilities, attack vectors, and defensive strategies.
            </p>
          </div>
          <div className="blog-card p-6">
            <h3 className="text-2xl font-steam text-cyber-green mb-3">Hacking</h3>
            <p className="text-gray-iron text-sm">
              Ethical hacking techniques, penetration testing, and bug bounty hunting.
            </p>
          </div>
          <div className="blog-card p-6">
            <h3 className="text-2xl font-steam text-cyber-purple mb-3">Privacy</h3>
            <p className="text-gray-iron text-sm">
              Tools and techniques to protect your digital footprint and maintain
              anonymity.
            </p>
          </div>
          <div className="blog-card p-6">
            <h3 className="text-2xl font-steam text-steam-copper mb-3">Tutorials</h3>
            <p className="text-gray-iron text-sm">
              Step-by-step guides for security tools, secure coding, and best practices.
            </p>
          </div>
        </div>
      </div>

      {/* Terminal-style Contact */}
      <div className="terminal">
        <div className="terminal-header">
          <div className="flex gap-2">
            <div className="w-3 h-3 rounded-full bg-danger-red" />
            <div className="w-3 h-3 rounded-full bg-warning-orange" />
            <div className="w-3 h-3 rounded-full bg-success-green" />
          </div>
          <span className="ml-4 text-xs">contact.sh</span>
        </div>
        <div className="terminal-body space-y-2">
          <p>&gt; Get in touch</p>
          <p>&gt; Email: contact@teddy-kgb.com</p>
          <p>&gt; Twitter: @teddykgb</p>
          <p>&gt; GitHub: github.com/teddykgb</p>
          <p className="mt-4 text-cyber-blue">&gt; Always happy to discuss security research and collaborate!</p>
        </div>
      </div>
    </div>
  )
}
